import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Users, MessageSquare } from 'lucide-react';
export function Bonuses() {
  return <section className="bg-slate-950 py-12 md:py-20 relative overflow-hidden" data-id="element-36">
      <div className="absolute inset-0 opacity-5" data-id="element-37">
        <div className="absolute top-0 right-0 h-full w-1/2 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-amber-400 via-transparent to-transparent" data-id="element-38"></div>
      </div>

      <div className="container relative mx-auto px-4 sm:px-6 lg:px-8" data-id="element-39">
        <div className="mx-auto max-w-3xl text-center mb-10 md:mb-12" data-id="element-40">
          <div className="inline-flex items-center gap-1.5 rounded-full bg-amber-400/10 px-3 py-1 text-amber-400 mb-4 border border-amber-400/20" data-id="element-41">
            <Gift className="h-4 w-4" data-id="element-42" />
            <span className="text-xs font-bold tracking-wide uppercase" data-id="element-43">
              Oferta Especial
            </span>
          </div>
          <h2 className="text-2xl text-white md:text-4xl font-display" data-id="element-44">
            BONUS PROFESIONALES
            <br data-id="element-45" />
            <span className="text-amber-400" data-id="element-46">GRATIS POR EL DÍA DE HOY</span>
          </h2>
        </div>

        <div className="grid gap-4 md:gap-6 md:grid-cols-2 max-w-4xl mx-auto" data-id="element-47">
          {/* Bonus 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="relative rounded-2xl bg-slate-900 p-5 md:p-8 border border-slate-800 shadow-xl" data-id="element-48">
            <div className="absolute -top-3 -right-2 md:-right-4 rotate-6 rounded-md bg-amber-400 px-2.5 py-1 text-[10px] md:text-xs font-black text-slate-900 shadow-lg border border-amber-200 z-10" data-id="element-49">
              ¡Gratis Hoy!
            </div>

            <div className="mb-4 inline-flex h-10 w-10 md:h-12 md:w-12 items-center justify-center rounded-xl bg-slate-800 text-amber-400 border border-slate-700" data-id="element-50">
              <Users className="h-5 w-5 md:h-6 md:w-6" data-id="element-51" />
            </div>
            <h3 className="text-xs md:text-sm font-bold text-slate-400 mb-1 uppercase tracking-wider" data-id="element-52">
              BONUS #1
            </h3>
            <h4 className="text-base md:text-xl font-bold text-white mb-2 leading-tight" data-id="element-53">
              Comunicación con el cuerpo técnico
            </h4>
            <p className="text-xs md:text-sm text-slate-400 mb-4 leading-relaxed" data-id="element-54">
              Plantilla de reporte profesional lista para usar. Respondé con
              claridad cuando el cuerpo técnico te pregunta:{' '}
              <span className="text-emerald-400 italic" data-id="element-55">"¿Cómo lo ves?"</span>
            </p>

            <div className="space-y-1.5" data-id="element-56">
              {['Plantilla de reporte profesional', 'Tabla "evitar decir / mejor decir"', 'Nota de confidencialidad', 'Frases listas para usar'].map((item, i) => <div key={i} className="flex items-start gap-2 text-[11px] md:text-sm text-slate-300" data-id="element-57">
                  <div className="mt-1.5 h-1 w-1 shrink-0 rounded-full bg-amber-400" data-id="element-58" />
                  <span data-id="element-59">{item}</span>
                </div>)}
            </div>
          </motion.div>

          {/* Bonus 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="relative rounded-2xl bg-slate-900 p-5 md:p-8 border border-slate-800 shadow-xl" data-id="element-60">
            <div className="absolute -top-3 -right-2 md:-right-4 rotate-6 rounded-md bg-amber-400 px-2.5 py-1 text-[10px] md:text-xs font-black text-slate-900 shadow-lg border border-amber-200 z-10" data-id="element-61">
              ¡Gratis Hoy!
            </div>

            <div className="mb-4 inline-flex h-10 w-10 md:h-12 md:w-12 items-center justify-center rounded-xl bg-slate-800 text-amber-400 border border-slate-700" data-id="element-62">
              <MessageSquare className="h-5 w-5 md:h-6 md:w-6" data-id="element-63" />
            </div>
            <h3 className="text-xs md:text-sm font-bold text-slate-400 mb-1 uppercase tracking-wider" data-id="element-64">
              BONUS #2
            </h3>
            <h4 className="text-base md:text-xl font-bold text-white mb-2 leading-tight" data-id="element-65">
              Protocolo de primera sesión
            </h4>
            <p className="text-xs md:text-sm text-slate-400 mb-4 leading-relaxed" data-id="element-66">
              Guía específica para el primer contacto con el deportista. Para
              que no empieces improvisando desde el primer encuentro.
            </p>

            <div className="space-y-1.5" data-id="element-67">
              {['Guion de apertura y cierre', 'Encuadre de confidencialidad', 'Preguntas por bloques', 'Ficha editable de primera sesión'].map((item, i) => <div key={i} className="flex items-start gap-2 text-[11px] md:text-sm text-slate-300" data-id="element-68">
                  <div className="mt-1.5 h-1 w-1 shrink-0 rounded-full bg-amber-400" data-id="element-69" />
                  <span data-id="element-70">{item}</span>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}